import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Helper } from 'src/app/accountancy/utilities/classes/helper.class';
import { LiquidationItemHistory } from 'src/app/accountancy/utilities/interfaces/liquidation.interface';

@Component({
  selector: 'app-view-liquidation-item-history',
  templateUrl: './view-liquidation-item-history.component.html',
  styleUrls: ['./view-liquidation-item-history.component.scss']
})
export class ViewLiquidationItemHistoryComponent {

  public readonly Helper = Helper;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LiquidationItemHistory[],
  ) { }

}
